import React from 'react';
import { Row, OverlayTrigger, Popover } from 'react-bootstrap'
import config from '../../config';

// const currentYear = today.year();

class WhatsNextPopover extends React.Component {

    popover = (
        <Popover id="popover-basic" className="p-3 text-center">
            <h3 as="h3">What happens next?</h3>
            <div>
                <p className="mb-1">
                    <em>
                        Reciprocity payments collected from homes, small businesses and events across B.C. are deposited into the relevant Regional Indigenous-owned Reciprocity Trust. Reciprocity Nations decide how to use their allocated funds based on a set of Nation-determined priorities.
                    </em>
                    {/* <em>If you make your recommended Reciprocity payment for {currentYear}, we'll confirm your property is eligible for Reciprocity status (most are). If it is eligible, your payment will be processed and your home will be certified as an <FancyR text='home'/> based on the number of years you have contributed.</em> */}
                </p>
                <Row className="d-flex justify-content-center">
                    <a href={`${config.domains.marketing}/how-reciprocity-works/#what-next`} target="_blank" rel="noreferrer">
                        <button className="btn btn-link mb-2">More...</button>
                    </a>
                </Row>
            </div>
        </Popover>
    );

    render() {
        return (
            <OverlayTrigger trigger="click" placement="top" overlay={this.popover}>
                <button className="btn btn-link mb-3" style={{ color: '#93ba21' }}>
                    <h3 style={{ color: '#93ba21' }}>Where would my dollars go?</h3>
                </button>
            </OverlayTrigger>

        );
    }
}

export default WhatsNextPopover;
